import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CmsConfig, I18nModule, provideDefaultConfig, UrlModule} from '@spartacus/core';
import {IconModule, MediaModule} from '@spartacus/storefront';

import {AimoLandingPageTextComponent} from './aimo-landing-page-text.component';

@NgModule({
    imports: [CommonModule, RouterModule, IconModule, MediaModule, UrlModule, I18nModule],
    declarations: [AimoLandingPageTextComponent],
    exports: [AimoLandingPageTextComponent],
    providers: [
        provideDefaultConfig(<CmsConfig>{
            cmsComponents: {
                AimoLandingPageTextComponent: {
                    component: AimoLandingPageTextComponent,
                },
            },
        }),
    ],
})
export class AimoLandingPageTextModule {
}
